export const TAG_ARTICLE_LIST_DATA = {
  TAG_NAME: "t0",
  TAG_URI: "t1",
  PAGE_NUMBER: "t2",
};

export const BUZZ_TAGGED_ARTICLES_LIST_FLOW =
  "BUZZ_TAGGED_ARTICLES_LIST";
export const BUZZ_TAGGED_ARTICLES_LIST_PAGINATION_FLOW =
  "BUZZ_TAGGED_ARTICLES_LIST_PAGINATION";

export const TAG_PAGE_DATA = {
  NAME: "t3",
  URL: "t4",
  PAGE_NUMBER: "t5",
};
